import { Field, Form, Formik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import KibabMenu from "../../../../assets/icons/kibab-menu";
import { useDispatch } from "react-redux";
import {
  addItemTypeAction,
  deleteItemTypeAction,
  itemTypeListAction,
  updateItemTypeAction,
} from "../../../../redux/actions/settings-action";
import errorToast from "../../../helper-components/error-toast";
import DeleteIcon from "../../../../assets/icons/delete-icon";
import successToast from "../../../helper-components/success-toast";
import AddButton from "../../../buttons/button";
import LoadingSpinner from "../../../helper-components/loading-spinner";

const ItemTypeTable = ({ searchValue, reload }) => {
  const tableHeading = ["Type Code", "Type Name", "Action"];
  const [disableArrayFields, setDisableArrayFields] = useState(false);
  const [disableNewFields, setDisableNewFields] = useState(false);
  const [selectedDOtIndex, setSelectedDOtIndex] = useState(null);
  const [initialData, setItemTypeData] = useState([]);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const handleFieldChange = (index, field, value, setFieldValue) => {
    setFieldValue(`${index}.${field}`, value);
  };

  useEffect(() => {
    setLoading(true);
    dispatch(
      itemTypeListAction({}, onFetchItemTypeSuccess, onFetchItemTypeError)
    );
  }, []);

  useEffect(() => {
    dispatch(
      itemTypeListAction(
        { searchValue },
        onFetchItemTypeSuccess,
        onFetchItemTypeError
      )
    );
    setLoading(true);
  }, [searchValue, reload]);

  const reloadData = () => {
    setLoading(true);
    dispatch(
      itemTypeListAction({}, onFetchItemTypeSuccess, onFetchItemTypeError)
    );
  };

  const onFetchItemTypeSuccess = (data) => {
    setItemTypeData(data?.data?.itemTypeList);
    setLoading(false);
  };

  const onFetchItemTypeError = (data) => {
    setLoading(false);
    setItemTypeData([]);
    errorToast(data?.data?.message);
  };

  const initialValues = {
    data: initialData,
    newLine: {
      code: "",
      name: "",
    },
  };

  const onSubmit = (values, { setSubmitting }) => {
    const changedObjects = [];
    let newLineObject = null;
    initialData.forEach((item, index) => {
      if (JSON.stringify(values.data[index]) !== JSON.stringify(item)) {
        changedObjects.push(values.data[index]);
      }
    });
    if (
      JSON.stringify(values.newLine) !== JSON.stringify(initialValues.newLine)
    ) {
      newLineObject = values.newLine;
    }

    if (newLineObject !== null) {
      if (newLineObject.code === "" || newLineObject.name === "") {
        errorToast("Please fill all the fields in the new line.");
        setSubmitting(false);
        return;
      }
      dispatch(
        addItemTypeAction(newLineObject, onCreateSuccess, onCreateError)
      );
    }

    if (changedObjects.length > 0) {
      dispatch(
        updateItemTypeAction(
          { updatingData: changedObjects },
          onUpdateSuccess,
          onUpdateError
        )
      );
    }
    setSubmitting(false);
  };

  const onCreateSuccess = (data) => {
    reloadData();
    setDisableArrayFields(false);
    setDisableNewFields(false);
    successToast(data?.message);
    setSelectedDOtIndex(null);
  };
  const onCreateError = (data) => {
    setDisableArrayFields(false);
    setDisableNewFields(false);
    errorToast(data?.data?.message);
    setSelectedDOtIndex(null);
  };

  const onUpdateSuccess = (data) => {
    reloadData();
    setDisableArrayFields(false);
    setDisableNewFields(false);
    successToast(data?.message);
    setSelectedDOtIndex(null);
  };
  const onUpdateError = (data) => {
    setDisableArrayFields(false);
    setDisableNewFields(false);
    errorToast(data?.data?.message);

    setSelectedDOtIndex(null);
  };

  const componentRef = useRef(null);
  const handleClickOutside = (event) => {
    if (componentRef.current && !componentRef.current.contains(event.target)) {
      setSelectedDOtIndex(null);
    }
  };

  const onClickDelete = (id) => {
    dispatch(deleteItemTypeAction({ id }, onDeletSuccess, onError));
  };
  const onDeletSuccess = (data) => {
    reloadData();
    setDisableArrayFields(false);
    setDisableNewFields(false);
    successToast(data?.message);
  };

  const onError = (data) => {
    errorToast(data?.data?.message);

    selectedDOtIndex(null);
  };

  return (
    <Formik
      enableReinitialize={true}
      initialValues={initialValues}
      onSubmit={onSubmit}
    >
      {({ values, setFieldValue, handleSubmit }) => (
        <Form className="pt-1">
          <div
            onClick={handleClickOutside}
            className="flex flex-col justify-between"
            style={{ height: "75vh" }}
          >
            {loading ? (
              <LoadingSpinner />
            ) : (
              <div className="overflow-auto mb-auto rounded-xl table-container border border-gray-200">
                <table className=" w-full ">
                  <thead className="sticky top-0 bg-[var(--create-table-header-bg)] z-[10]">
                    <tr className="relative h-[50px]">
                      {tableHeading.map((heading, index) => (
                        <th
                          className={`text-start px-[8px] whitespace-nowrap text-[var(--create-table-header-fg)] text-[length:var(--create-table-header-fs)] font-[var(--create-table-header-fw)]`}
                          key={heading}
                        >
                          {heading}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody style={{ position: "relative" }}>
                    {values.data.map((item, index) => (
                      <tr
                        className={` bg-[var(--list-table-row-bg)]
                         h-[50px] `}
                        key={index}
                      >
                        <td className="tab-cell text-sm fw_400 text-secondary w-3/12">
                          <Field
                            name={`data[${index}].code`}
                            placeholder="Code"
                            disabled={disableArrayFields}
                            onChange={(e) => {
                              const rawValue = e.target.value;
                              const cleanedValue = rawValue.replace(
                                /[^a-zA-Z0-9]/g,
                                ""
                              );

                              if (rawValue !== cleanedValue) {
                                // 🚨 Invalid character found
                                errorToast(
                                  "Only letters and numbers are allowed"
                                );
                              }
                              handleFieldChange(
                                `data[${index}]`,
                                "code",
                                cleanedValue,
                                setFieldValue
                              );
                            }}
                            maxLength={15}
                            className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded px-1 py-2"
                          />
                        </td>
                        <td className="tab-cell text-sm fw_400 text-secondary w-7/12">
                          <Field
                            name={`data[${index}].name`}
                            placeholder="Name"
                            disabled={disableArrayFields}
                            onChange={(e) => {
                              let value = e.target.value;
                              const originalValue = value;

                              // 1. Remove special characters (only letters, numbers, spaces allowed)
                              value = value.replace(/[^a-zA-Z0-9 ]/g, "");

                              // Show error toast if invalid characters were entered
                              if (originalValue !== value) {
                                errorToast(
                                  "Only letters, numbers, and spaces are allowed"
                                );
                              }

                              // 2. Prevent leading space
                              value = value.replace(/^\s+/, "");

                              // 3. Prevent consecutive spaces and show error toast
                              if (value !== value.replace(/\s+/g, " ")) {
                                errorToast(
                                  "Consecutive spaces are not allowed"
                                );
                              }
                              value = value.replace(/\s+/g, " ");

                              handleFieldChange(
                                `data[${index}]`,
                                "name",
                                value,
                                setFieldValue
                              );
                            }}
                            maxLength={20}
                            className="w-full border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded py-2"
                          />
                        </td>
                        <td className="tab-cell text-sm fw_400 text-secondary w-2/12">
                          <div className="flex items-center">
                            <button
                              type="button"
                              onClick={() => onClickDelete(item?.id)}
                            >
                              <DeleteIcon />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                    <tr>
                      <td className={`tab-cell text-sm fw_400 text-secondary`}>
                        <Field
                          name="newLine.code"
                          placeholder="Code"
                          disabled={disableNewFields}
                          onChange={(e) => {
                            const rawValue = e.target.value;
                            const cleanedValue = rawValue.replace(
                              /[^a-zA-Z0-9]/g,
                              ""
                            );

                            if (rawValue !== cleanedValue) {
                              // 🚨 Invalid character found
                              errorToast(
                                "Only letters and numbers are allowed"
                              );
                            }
                            handleFieldChange(
                              `newLine`,
                              "code",
                              cleanedValue,
                              setFieldValue
                            );
                          }}
                          maxLength={15}
                          className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded py-2"
                          autoFocus={searchValue ? false : true}
                        />
                      </td>
                      <td className={`tab-cell text-sm fw_400 text-secondary`}>
                        <Field
                          name="newLine.name"
                          placeholder="Name"
                          disabled={disableNewFields}
                          onChange={(e) => {
                            let value = e.target.value;
                            const originalValue = value;

                            // 1. Remove special characters (only letters, numbers, spaces allowed)
                            value = value.replace(/[^a-zA-Z0-9 ]/g, "");

                            // Show error toast if invalid characters were entered
                            if (originalValue !== value) {
                              errorToast(
                                "Only letters, numbers, and spaces are allowed"
                              );
                            }

                            // 2. Prevent leading space
                            value = value.replace(/^\s+/, "");

                            // 3. Prevent consecutive spaces and show error toast
                            if (value !== value.replace(/\s+/g, " ")) {
                              errorToast("Consecutive spaces are not allowed");
                            }
                            value = value.replace(/\s+/g, " ");

                            handleFieldChange(
                              "newLine",
                              "name",
                              value,
                              setFieldValue
                            );
                          }}
                          maxLength={20}
                          className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded py-2"
                        />
                      </td>
                      <td
                        className={`tab-cell text-sm fw_400 text-secondary`}
                      ></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            )}

            <div className="mt-auto flex gap-3 items-center justify-end w-full h-[4rem]">
              <AddButton
                onclkFn={handleSubmit}
                prefixIcon={false}
                text="Save"
                type="submit"
                className="
    flex items-center px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
    bg-[var(--primary-button-bg-color)] cursor-pointer
    text-[var(--primary-button-fg-color)]
    border border-[var(--primary-button-bg-color)]
    hover:bg-[var(--primary-button-hover-color)]
    text-[length:var(--primary-button-create-fs)] 
    font-[var(--primary-button-font-weight)]
    "
              />
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default ItemTypeTable;
